import "./styles.scss";

const StatusInfoCard = ({ statusText, statusTime, dotColor }) => {
  return (
    <>
      <div className="status-info-box">
        <div className="status-label">
          <span
            className="status-dot"
            style={{
              backgroundColor: `var(--bs-${
                dotColor ? dotColor : "warning-600"
              })`,
            }}
          />
          {statusText}
        </div>
        {statusTime ? (
          <div className="estimated-time">{`${statusTime}`}</div>
        ) : null}
      </div>
    </>
  );
};

export default StatusInfoCard;
